import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Modal, PERMS } from "../lib/ui.jsx";

export default function Permissions() {
  const { api, act } = useAuth();
  const [f, setF] = useState({ search: "", portal: "", role: "", page: 1 });
  const [d, reload] = useLoad("perms", f);
  const [pt] = useLoad("portals");
  const [e, setE] = useState(null);
  const [hits, setHits] = useState([]);
  const [q, setQ] = useState("");

  const find = async () => {
    try { setHits((await api("users", { params: { search: q, per: 8 } })).rows); } catch { setHits([]); }
  };
  const save = async () => { if (await act("perm_save", e, "Portal access saved.")) { setE(null); reload(); } };

  return (
    <>
      <h1>User permissions</h1>
      <div className="bar">
        <input placeholder="Search user" value={f.search} onChange={(x) => setF({ ...f, search: x.target.value, page: 1 })} />
        <select value={f.portal} onChange={(x) => setF({ ...f, portal: x.target.value, page: 1 })}>
          <option value="">All portals</option>
          {pt?.rows?.map((w) => <option key={w.id} value={w.portal}>{w.name}</option>)}
        </select>
        <select value={f.role} onChange={(x) => setF({ ...f, role: x.target.value, page: 1 })}>
          <option value="">All roles</option>
          {["user", "manager", "admin"].map((r) => <option key={r}>{r}</option>)}
        </select>
        <button className="btn" onClick={() => { setE({ sopnoid: "", c_refer: "", role: "user", can_view: 1 }); setHits([]); setQ(""); }}>Grant access</button>
      </div>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No permission rows match." onRowClick={(p) => setE({ ...p })} cols={[
              ["User", (p) => p.Name || p.sopnoid], ["Email", (p) => p.Email], ["Portal", (p) => p.portal_name || p.c_refer], ["Role", (p) => p.role],
              ["Rights", (p) => PERMS.filter((k) => +p[k]).map((k) => k.slice(4).replace(/_/g, " ")).join(", ") || "none"],
              ["", (p) => (
                <>
                  <button className="btn g s" onClick={() => setE({ ...p })}>Edit</button>{" "}
                  <button className="btn d s" onClick={() => confirm("Remove this access?") && act("perm_delete", { id: p.id }, "Access removed.").then(reload)}>Remove</button>
                </>
              )],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>
      {e && (
        <Modal title={e.id ? "Edit access" : "Grant portal access"} onClose={() => setE(null)}>
          {!e.id && (
            <>
              <label>Find user</label>
              <div className="bar" style={{ margin: 0 }}>
                <input value={q} onChange={(x) => setQ(x.target.value)} onKeyDown={(x) => x.key === "Enter" && find()} placeholder="Name, email or mobile" />
                <button className="btn g" onClick={find}>Search</button>
              </div>
              <select size={Math.min(5, hits.length || 1)} style={{ width: "100%", marginTop: 6 }} value={e.sopnoid} onChange={(x) => setE({ ...e, sopnoid: x.target.value })}>
                {hits.map((u) => <option key={u.SopnoID} value={u.SopnoID}>{u.Name} ({u.Email})</option>)}
              </select>
            </>
          )}
          {e.id && <p>{e.Name || e.sopnoid}</p>}
          <label>Portal</label>
          <select value={e.c_refer} disabled={!!e.id} onChange={(x) => setE({ ...e, c_refer: x.target.value })}>
            <option value="">Choose portal</option>
            {pt?.rows?.map((w) => <option key={w.id} value={w.portal}>{w.name} ({w.domain})</option>)}
          </select>
          <label>Role</label>
          <select value={e.role} onChange={(x) => setE({ ...e, role: x.target.value })}>
            {["user", "manager", "admin"].map((r) => <option key={r}>{r}</option>)}
          </select>
          <div className="g2" style={{ marginTop: 8 }}>
            {PERMS.map((k) => (
              <label className="chk" key={k}>
                <input type="checkbox" checked={!!+e[k]} onChange={(x) => setE({ ...e, [k]: x.target.checked ? 1 : 0 })} />
                {k.slice(4).replace(/_/g, " ")}
              </label>
            ))}
          </div>
          <div className="bar"><button className="btn" disabled={!e.sopnoid || !e.c_refer} onClick={save}>Save access</button></div>
        </Modal>
      )}
    </>
  );
}
